import { useEffect, useState } from 'react';

const KEYMAP = { a: 'approve', r: 'reject', s: 'skip', arrowright: 'next', arrowleft: 'prev', p: 'focusPdf', '?': 'help' };

// Keyboard shortcuts for the approval workspace. Ignored while typing in a field or while a modal is open.
export function useWorkspaceHotkeys(handlers, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const onKeyDown = (event) => {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey) return;
      const target = event.target;
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName) || target?.isContentEditable) return;
      if (document.querySelector('.Polaris-Modal-Dialog, [role="dialog"]')) return;
      const action = KEYMAP[String(event.key).toLowerCase()];
      if (action && typeof handlers[action] === 'function') {
        event.preventDefault();
        handlers[action]();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handlers, enabled]);
}

export function useIsDesktop() {
  const query = '(min-width: 48em)';
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (event) => setIsDesktop(event.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [setIsDesktop]);
  return isDesktop;
}
